"use client"

import axios from 'axios'

import { PHRASE_CACHE_KEY_PREFIX } from '@/constants/constants'

interface TranslationResponse {
  [key: string]: {
    message: string
  }
}

/**
 *
 * @param locale the language to fetch json key file
 */
async function fetchTranslations(locale: string): Promise<TranslationResponse> {
  try {
    const cacheKey = `${PHRASE_CACHE_KEY_PREFIX}${locale}`
    // First, try to read from local storage (client-side)
    if (typeof window !== 'undefined') {
      const cachedData = localStorage.getItem(cacheKey)
      if (cachedData) {
        const parsedData = JSON.parse(cachedData)
        if (parsedData.expiration > Date.now()) {
          return parsedData.data
        } else {
          localStorage.removeItem(cacheKey)
        }
      }
    }

    // Fetch translations from your API route
    const response = await axios.get('/api/fetch-translations')

    // Store the fetched translations in local storage (client-side) with an expiration timestamp
    if (typeof window !== 'undefined') {
      const expiration = Date.now() + 5 * 60 * 1000 // 5 minutes
      const dataToCache = {
        data: response.data,
        expiration,
      }
      localStorage.setItem(cacheKey, JSON.stringify(dataToCache))
    }

    return response.data
  } catch (error) {
    console.error('Error fetching translations:', error)
    return {}
  }
}

export default fetchTranslations
